import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import dftRatings from "../../../../src/data/articles/cube-prospective-aetherdrift/dft-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  dftRatings,
  ProspectiveIntro,
  React
};